'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var crypto = require('./crypto');

var debug = require('debug');

var log = debug('libp2p:secio');
log.error = debug('libp2p:secio:error'); // step 2. Exchange
// -- exchange (signed) ephemeral keys. verify signatures.

module.exports = /*#__PURE__*/function () {
  var _exchange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, wrapped) {
    var ex, msg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log('2. exchange - start');
            log('2. exchange - writing exchange');
            _context.next = 4;
            return crypto.createExchange(state);

          case 4:
            ex = _context.sent;
            _context.next = 7;
            return wrapped.writeLP(ex);

          case 7:
            _context.next = 9;
            return wrapped.readLP();

          case 9:
            msg = _context.sent;
            log('2. exchange - reading exchange');
            _context.next = 13;
            return crypto.verify(state, msg.slice());

          case 13:
            _context.next = 15;
            return crypto.generateKeys(state);

          case 15:
            log('2. exchange - finish');

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function exchange(_x, _x2) {
    return _exchange.apply(this, arguments);
  }

  return exchange;
}();